export enum SubscriptionPlanListModalTypesEnum {
  DOWNGRADE = 'downgrade',
  UPGRADE_ROLLOVER_WARNING = 'upgrade_rollover_warning'
}
